import api from '../../../api';
import type { GlossaryTerm } from '../../../api/custom/Glossary';

let cached: GlossaryTerm[] = [];

export async function loadGlossary(): Promise<GlossaryTerm[]> {
    const terms = await api.glossary.getAllWithoutCache();
    cached = terms;
    return terms;
}

export function getGlossary(): GlossaryTerm[] {
    return cached;
}
